// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header-module__frame-Header--vTiMG {
  background: var(--chaek-color-surface-canvas, #ffffff);
  border-bottom: 1px solid var(--chaek-color-border-navigation, #e7e7e9);
  width: 100%;
  height: 76px;
}

.Header-module__wrap--PINMI {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: var(--layout-width);
  height: 100%;
  padding: 0 44px;
  margin: 0 auto;
  box-sizing: border-box;
}

.Header-module__frame-Header-Logo--dbvNa {
  display: inline-flex;
  align-items: center;
  margin: 0;
}

.Header-module__frame-Header-Logo--dbvNa a {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
}

.Header-module__frame-Header-Logo--dbvNa .Header-module__img--JopX_ {
  display: flex;
  flex-shrink: 0;
  width: 46px;
  height: 46px;
}

.Header-module__frame-Header-Logo--dbvNa .Header-module__img--JopX_ img {
  display: block;
  width: 46px;
  height: 46px;
  object-fit: contain;
}

.Header-module__frame-Header-Logo--dbvNa .Header-module__text--U1myF {
  font-size: 22px;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -1.2578px;
  color: var(--chaek-color-text-primary, #191919);
}

.Header-module__frame-Header-Nav--vEdkB {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 40px;
}

.Header-module__frame-Header-Nav--vEdkB a {
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: -0.1504px;
  color: var(--chaek-color-text-inactive, #858585);
  padding-bottom: 2px;
  border-bottom: 2px solid transparent;
  text-decoration: none;
}

.Header-module__frame-Header-Nav--vEdkB a.Header-module__is-active--BdT0M {
  color: var(--chaek-color-text-primary, #191919);
  border-bottom-color: var(--chaek-color-border-strong, #191919);
}

.Header-module__actions--SQFIB {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 250px;
  flex-shrink: 0;
}

.Header-module__frame-Header-ProfileButton--U0aGh {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  box-sizing: border-box;
  padding: 0;
  border: 1px solid #000000;
  border-radius: 20px;
  background: #ffffff;
  cursor: pointer;
  margin-left: 16px;
}

.Header-module__frame-Header-ProfileButton--U0aGh img {
  display: block;
  width: 19px;
  height: 23px;
}

.Header-module__frame-Header--vTiMG.Header-module__is-reverse--N4xLt {
  background: #090a0c;
  border-bottom-color: #333333;
}

.Header-module__frame-Header--vTiMG.Header-module__is-reverse--N4xLt .Header-module__frame-Header-Logo--dbvNa .Header-module__text--U1myF {
  color: var(--chaek-color-text-inverse, #ffffff);
}

.Header-module__frame-Header--vTiMG.Header-module__is-reverse--N4xLt .Header-module__frame-Header-Nav--vEdkB a {
  color: var(--chaek-color-text-source-bdbdbd, #bdbdbd);
}

.Header-module__frame-Header--vTiMG.Header-module__is-reverse--N4xLt .Header-module__frame-Header-Nav--vEdkB a.Header-module__is-active--BdT0M {
  color: var(--chaek-color-text-inverse, #ffffff);
  border-bottom-color: var(--chaek-color-border-source-ffffff, #ffffff);
}

.Header-module__frame-Header--vTiMG.Header-module__is-reverse--N4xLt .Header-module__frame-Header-ProfileButton--U0aGh {
  border-color: var(--chaek-color-border-source-ffffff, #ffffff);
  background: transparent;
}

.Header-module__frame-Header--vTiMG.Header-module__is-reverse--N4xLt .Header-module__frame-Header-ProfileButton--U0aGh img {
  filter: invert(1);
}
`, "",{"version":3,"sources":["webpack://./src/frames/Header/Header.module.css"],"names":[],"mappings":"AAAA;EACE,sDAAsD;EACtD,sEAAsE;EACtE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,0BAA0B;EAC1B,YAAY;EACZ,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,gDAAgD;EAChD,mBAAmB;EACnB,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,+CAA+C;EAC/C,8DAA8D;AAChE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,UAAU;EACV,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,+CAA+C;EAC/C,qEAAqE;AACvE;;AAEA;EACE,8DAA8D;EAC9D,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".frame-Header {\n  background: var(--chaek-color-surface-canvas, #ffffff);\n  border-bottom: 1px solid var(--chaek-color-border-navigation, #e7e7e9);\n  width: 100%;\n  height: 76px;\n}\n\n.wrap {\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: var(--layout-width);\n  height: 100%;\n  padding: 0 44px;\n  margin: 0 auto;\n  box-sizing: border-box;\n}\n\n.frame-Header-Logo {\n  display: inline-flex;\n  align-items: center;\n  margin: 0;\n}\n\n.frame-Header-Logo a {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  text-decoration: none;\n}\n\n.frame-Header-Logo .img {\n  display: flex;\n  flex-shrink: 0;\n  width: 46px;\n  height: 46px;\n}\n\n.frame-Header-Logo .img img {\n  display: block;\n  width: 46px;\n  height: 46px;\n  object-fit: contain;\n}\n\n.frame-Header-Logo .text {\n  font-size: 22px;\n  font-weight: 400;\n  line-height: normal;\n  letter-spacing: -1.2578px;\n  color: var(--chaek-color-text-primary, #191919);\n}\n\n.frame-Header-Nav {\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  align-items: center;\n  gap: 40px;\n}\n\n.frame-Header-Nav a {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 21px;\n  letter-spacing: -0.1504px;\n  color: var(--chaek-color-text-inactive, #858585);\n  padding-bottom: 2px;\n  border-bottom: 2px solid transparent;\n  text-decoration: none;\n}\n\n.frame-Header-Nav a.is-active {\n  color: var(--chaek-color-text-primary, #191919);\n  border-bottom-color: var(--chaek-color-border-strong, #191919);\n}\n\n.actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  width: 250px;\n  flex-shrink: 0;\n}\n\n.frame-Header-ProfileButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 44px;\n  height: 44px;\n  box-sizing: border-box;\n  padding: 0;\n  border: 1px solid #000000;\n  border-radius: 20px;\n  background: #ffffff;\n  cursor: pointer;\n  margin-left: 16px;\n}\n\n.frame-Header-ProfileButton img {\n  display: block;\n  width: 19px;\n  height: 23px;\n}\n\n.frame-Header.is-reverse {\n  background: #090a0c;\n  border-bottom-color: #333333;\n}\n\n.frame-Header.is-reverse .frame-Header-Logo .text {\n  color: var(--chaek-color-text-inverse, #ffffff);\n}\n\n.frame-Header.is-reverse .frame-Header-Nav a {\n  color: var(--chaek-color-text-source-bdbdbd, #bdbdbd);\n}\n\n.frame-Header.is-reverse .frame-Header-Nav a.is-active {\n  color: var(--chaek-color-text-inverse, #ffffff);\n  border-bottom-color: var(--chaek-color-border-source-ffffff, #ffffff);\n}\n\n.frame-Header.is-reverse .frame-Header-ProfileButton {\n  border-color: var(--chaek-color-border-source-ffffff, #ffffff);\n  background: transparent;\n}\n\n.frame-Header.is-reverse .frame-Header-ProfileButton img {\n  filter: invert(1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"frame-Header": `Header-module__frame-Header--vTiMG`,
	"wrap": `Header-module__wrap--PINMI`,
	"frame-Header-Logo": `Header-module__frame-Header-Logo--dbvNa`,
	"img": `Header-module__img--JopX_`,
	"text": `Header-module__text--U1myF`,
	"frame-Header-Nav": `Header-module__frame-Header-Nav--vEdkB`,
	"is-active": `Header-module__is-active--BdT0M`,
	"actions": `Header-module__actions--SQFIB`,
	"frame-Header-ProfileButton": `Header-module__frame-Header-ProfileButton--U0aGh`,
	"is-reverse": `Header-module__is-reverse--N4xLt`
};
export default ___CSS_LOADER_EXPORT___;
